import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

import * as BulkAssemblyActions from '../BulkAssemblyActions';
import {BULK_ASSEMBLY_STATE, LocalAssembly} from '../BulkAssemblyConstants';

interface ValidationStatusProps {
  assembly: LocalAssembly;
}

export default function ValidationStatus({assembly}: ValidationStatusProps): JSX.Element | null {
  switch (assembly.meta.state) {
    case BULK_ASSEMBLY_STATE.UNVALIDATED: // Allow user to re-try validation
      return (
        <Button
          buttonStyle={ButtonStyle.SECONDARY}
          size={ButtonSize.MEDIUM}
          onClick={BulkAssemblyActions.validate}
          text="Re-validate"
        />
      );
    default:
      return null;
  }
}
